import type { ObjectId } from '@freightview/object-id'

import { vArray, vEmail, vObject, type vOutput } from '../validation/index.ts'
import type { ExpandedSpotQuoteContact } from './spot-quote-contact.ts'

export const addGroupContactsSchema = vObject({
  emails: vArray(vEmail),
})

export type AddGroupContactsDTO = vOutput<typeof addGroupContactsSchema>

export interface SpotQuoteGroup {
  groupId: ObjectId
  groupName: string
}

export interface SpotQuoteGroupWithUsers extends SpotQuoteGroup {
  users: ExpandedSpotQuoteContact[]
}
